import React from 'react';
import { useTranslation } from 'react-i18next';
import { MultiStatCard } from 'components/StatCard';
import { useRouter } from 'next/router';
import { useGetEventAnalytics } from 'legacy/events/hooks';
import DownloadCSVButton from '../DownloadCSVButton';
import { currencyFormat } from 'legacy/common/utils/currency';

const CampaignSection = ({
  isOrganizer,
  onClickExportAnalytics,
  isFetchingExportAnalytics
}: {
  isOrganizer: boolean;
  onClickExportAnalytics: () => void;
  isFetchingExportAnalytics: boolean;
}) => {
  const { t } = useTranslation(['events']);
  const router = useRouter();
  const eventId = router.query.slug as string;
  const { data: eventAnalytics } = useGetEventAnalytics(eventId, isOrganizer);

  return (
    <div>
      <div className="flex justify-between  mb-4 items-center">
        <h2 className="text-xl font-bold flex flex-row">
          <img src="/img/events/campaign.svg" alt="campaign" /> &nbsp;{' '}
          {t('events:dashboard.campaigns.title')}
        </h2>
        <div className="flex text-right">
          <DownloadCSVButton
            onClick={onClickExportAnalytics}
            loading={isFetchingExportAnalytics}
          />
        </div>
      </div>

      <div className="flex justify-between space-x-4">
        <MultiStatCard
          title={`${t('events:dashboard.campaigns.trackingLinks')} (${
            eventAnalytics?.trackingLinks?.count
          })`}
          className="w-1/2"
          iconUrl="/img/events/hiperlink.svg"
          stats={[
            {
              label: t('events:dashboard.campaigns.views'),
              value:
                eventAnalytics?.trackingLinks?.views === 0
                  ? '-'
                  : eventAnalytics?.trackingLinks?.views
            },
            {
              label: t('events:dashboard.campaigns.sales'),
              value:
                eventAnalytics?.trackingLinks?.sales === 0
                  ? '-'
                  : eventAnalytics?.trackingLinks?.sales
            },
            {
              label: t('events:dashboard.campaigns.revenue'),
              value:
                eventAnalytics?.trackingLinks?.revenue === 0
                  ? '-'
                  : currencyFormat(eventAnalytics?.trackingLinks?.revenue)
            }
          ]}
          onClick={() => {
            router.push(`/events/${eventId}?view=analytics`);
          }}
        />
        <MultiStatCard
          title={`${t('events:dashboard.campaigns.discountCodes')} (${
            eventAnalytics?.discountCodes?.activeCount
          })`}
          className="w-1/2"
          iconUrl="/img/events/discount.svg"
          stats={[
            {
              label: t('events:dashboard.campaigns.active'),
              value:
                eventAnalytics?.discountCodes?.activeCount === 0
                  ? '-'
                  : eventAnalytics?.discountCodes?.activeCount
            },
            {
              label: t('events:dashboard.campaigns.paused'),
              value:
                eventAnalytics?.discountCodes?.pausedCount === 0
                  ? '-'
                  : eventAnalytics?.discountCodes?.pausedCount
            },
            {
              label: t('events:dashboard.campaigns.sales'),
              value:
                eventAnalytics?.discountCodes?.revenue === 0
                  ? '-'
                  : currencyFormat(eventAnalytics?.discountCodes?.revenue)
            }
          ]}
          onClick={() => {
            router.push(`/events/${eventId}?view=discountCodes`);
          }}
        />
      </div>
    </div>
  );
};

export default CampaignSection;
